import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesWarehouseMain } from './modules/ui/Main';

const WarehousePage = (
  <SuspensePage>
    <PagesWarehouseMain />
  </SuspensePage>
);

export default WarehousePage;
